<template>
    <b-form-invalid-feedback :state="!isInvalid"
            v-html="feedback(validation)"></b-form-invalid-feedback>
</template>

<script>
export default {
  name: 'inputFeedback',
  props: {
    validation: Object,
    useError: Boolean
  },
  methods: {
    feedback(validInfo) {
      if (validInfo.required === false) {
        return this.$t('general:validation.required');
      } else if (validInfo.min === false) {
        return this.$t('general:validation.minValue', { value: validInfo.$params.min.min });
      } else if (validInfo.minLength === false) {
        if ((validInfo.$params.maxLength) && (validInfo.$params.minLength.min === validInfo.$params.maxLength.max)) {
          return this.$t('general:validation.fixedLength', { value: validInfo.$params.minLength.min });
        } else {
          return this.$t('general:validation.minLength', { value: validInfo.$params.minLength.min });
        }
      } else if (validInfo.maxLength === false) {
        if ((validInfo.$params.minLength) && (validInfo.$params.minLength.min === validInfo.$params.maxLength.max)) {
          return this.$t('general:validation.fixedLength', { value: validInfo.$params.maxLength.max });
        } else {
          return this.$t('general:validation.maxLength', { value: validInfo.$params.maxLength.max });
        }
      }
      return '';
    }
  },
  computed: {
    isInvalid() {
      if (this.useError) {
        return this.validation.$error;
      } else {
        return this.validation.$invalid;
      }
    }
  }
};
</script>

<style scoped>

</style>
